/**
 * LOUIEVALE BUNDLE SUGGESTION — MOBILE & DESKTOP SAFE
 * Hooks directly into /cart/add.js
 * This is the ONLY reliable way on Shopify mobile
 */

(function () {
  'use strict';

  const CONFIG = {
    leadRopeHandle: 'standard-marine-lead-rope',
    bundleDiscount: 2.00
  };

  class SmartBundleSuggestion {
    constructor() {
      this.leadRopeData = null;
      this.init();
    }

    async init() {
      await this.loadLeadRopeData();
      this.hookIntoAddToCart();
    }

    async loadLeadRopeData() {
      const res = await fetch(`/products/${CONFIG.leadRopeHandle}.js`);
      if (res.ok) this.leadRopeData = await res.json();
    }

    hookIntoAddToCart() {
      const originalFetch = window.fetch;

      window.fetch = async (...args) => {
        const response = await originalFetch(...args);

        try {
          const url = args[0]?.toString() || '';

          if (url.includes('/cart/add.js') && response.ok) {
            const addedItem = await response.clone().json();
            this.handleAddedItem(addedItem);
          }
        } catch (e) {
          console.error('[Bundle] Fetch hook error', e);
        }

        return response;
      };
    }

    async handleAddedItem(addedItem) {
      if (!this.isHalter(addedItem)) return;

      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      if (this.cartHasLeadRope(cart)) return;

      this.showBundleSuggestion(addedItem);
    }

    isHalter(item) {
      return (
        item.product_type?.toLowerCase().includes('halter') ||
        item.handle?.toLowerCase().includes('halter') ||
        item.title?.toLowerCase().includes('halter')
      );
    }

    cartHasLeadRope(cart) {
      return cart.items.some(i =>
        i.title.toLowerCase().includes('lead') &&
        !i.title.toLowerCase().includes('halter')
      );
    }

    findMatchingLeadVariant(halterVariantName) {
      if (!this.leadRopeData) return null;

      const color = halterVariantName.split('/')[0].trim().toLowerCase();

      return this.leadRopeData.variants.find(v =>
        v.title.toLowerCase().includes(color)
      );
    }

    showBundleSuggestion(halterItem) {
      if (document.querySelector('.bundle-suggestion-modal')) return;

      const halterVariantName = halterItem.variant_title || '';
      const matchingVariant = this.findMatchingLeadVariant(halterVariantName);

      let image = this.leadRopeData.featured_image;
      if (matchingVariant?.featured_image) {
        image = matchingVariant.featured_image.src;
      }

      const originalPrice = matchingVariant
        ? (matchingVariant.price / 100).toFixed(2)
        : (this.leadRopeData.price / 100).toFixed(2);

      const bundlePrice = (originalPrice - CONFIG.bundleDiscount).toFixed(2);

      /* ⚠️ YOUR HTML IS UNTOUCHED ⚠️ */
      const modalHtml = `
        <div class="bundle-suggestion-modal">
          <div class="bundle-suggestion-overlay"></div>
          <div class="bundle-suggestion-content">
            <button class="bundle-close">×</button>

            <div class="bundle-header">
              <h3>🎉 You're so close to completing the set!</h3>
              <p class="bundle-savings">Save $${CONFIG.bundleDiscount} when you bundle</p>
            </div>

            <div class="bundle-product">
              <div class="bundle-product-image">
                <img src="${image}">
                ${matchingVariant ? `<span class="bundle-color-badge">${halterVariantName.split('/')[0]}</span>` : ''}
              </div>

              <div class="bundle-product-info">
                <h4>${this.leadRopeData.title}</h4>

                ${matchingVariant
                  ? `<p class="bundle-variant">Color: ${matchingVariant.title}</p>`
                  : `<p class="bundle-variant">Choose your color on the product page</p>`}

                <div class="bundle-pricing">
                  <span class="bundle-original-price">$${originalPrice}</span>
                  <span class="bundle-price">$${bundlePrice}</span>
                  <span class="bundle-badge">Bundle Price</span>
                </div>

                <p class="bundle-message">
                  Perfect match for your ${halterItem.title}!
                </p>

                <div class="bundle-actions">
                  ${matchingVariant ? `
                    <button class="bundle-quick-add" data-variant-id="${matchingVariant.id}">
                      Quick Add to Cart
                    </button>` : ''}

                  <a href="/products/${CONFIG.leadRopeHandle}" class="bundle-view-product">
                    View Lead Rope
                  </a>
                </div>

                <p class="bundle-note">
                  * Discount automatically applied at checkout
                </p>
              </div>
            </div>
          </div>
        </div>`;

      document.body.insertAdjacentHTML('beforeend', modalHtml);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      this.attachListeners();
    }

    attachListeners() {
      document.querySelector('.bundle-close')?.addEventListener('click', () => this.close());
      document.querySelector('.bundle-suggestion-overlay')?.addEventListener('click', () => this.close());

      document.querySelector('.bundle-quick-add')?.addEventListener('click', async e => {
        const btn = e.currentTarget;
        btn.disabled = true;
        btn.textContent = 'Adding…';

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: btn.dataset.variantId, quantity: 1 })
        });

        btn.textContent = '✓ Added';
        setTimeout(() => this.close(), 700);
      });
    }

    close() {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      document.querySelector('.bundle-suggestion-modal')?.remove();
    }
  }

  new SmartBundleSuggestion();
})();

// Add this to your existing JavaScript or as a separate file

// Mobile scroll fix for bundle modal
(function() {
  'use strict';
  
  // Store original body position
  let scrollPosition = 0;
  
  // Function to lock body scroll
  window.lockBodyScroll = function() {
    scrollPosition = window.pageYOffset;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.width = '100%';
    document.body.classList.add('bundle-modal-open');
  };
  
  // Function to unlock body scroll
  window.unlockBodyScroll = function() {
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.classList.remove('bundle-modal-open');
    window.scrollTo(0, scrollPosition);
  };
  
  // Modify your existing modal show function
  const originalShow = window.SmartBundleSuggestion?.prototype?.showBundleSuggestion;
  if (originalShow) {
    window.SmartBundleSuggestion.prototype.showBundleSuggestion = function(...args) {
      originalShow.apply(this, args);
      // Lock scroll when modal opens
      if (window.innerWidth <= 600) {
        lockBodyScroll();
      }
    };
  }
  
  // Modify your existing close function
  const originalClose = window.SmartBundleSuggestion?.prototype?.close;
  if (originalClose) {
    window.SmartBundleSuggestion.prototype.close = function() {
      originalClose.apply(this);
      // Unlock scroll when modal closes
      unlockBodyScroll();
    };
  }
  
  // Alternative: Hook into modal creation/removal with MutationObserver
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.classList?.contains('bundle-suggestion-modal')) {
          if (window.innerWidth <= 600) {
            lockBodyScroll();
          }
        }
      });
      mutation.removedNodes.forEach((node) => {
        if (node.classList?.contains('bundle-suggestion-modal')) {
          unlockBodyScroll();
        }
      });
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: false
  });
  
})();